import { render, staticRenderFns } from "./TermoAlienacao.vue?vue&type=template&id=0c60fb96&"
import script from "./TermoAlienacao.vue?vue&type=script&lang=js&"
export * from "./TermoAlienacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports